import React from 'react'

import { Row, Col } from '_zari/core'

import * as FormGroups from './formGroups'

const ParametrosSection = ({ isSubmitting, values, errors, touched }) => {
  return (
    <Row>
      <Col md={12}>
        <FormGroups.FlagAtencionIslaFormGroup fIsSubmitting={isSubmitting} iValue={values.flagAtencionIsla} />
        {values.flagAtencionIsla && <FormGroups.IdIslaFormGroup iError={errors._idIsla} iTouched={touched._idIsla} fIsSubmitting={isSubmitting} />}
      </Col>
    </Row>
  )
}

export default React.memo(ParametrosSection)
